import { Component } from '@angular/core';
import { StorageProvider } from '../../providers/storage-service/storage-service';
import { ModalController, NavController, NavParams } from 'ionic-angular';
import { EditAthleteData } from '../../pages/edit-athlete-data/edit-athlete-data';
import { IterableDiffers, DoCheck } from '@angular/core';


@Component({
    selector: 'scoreboard-bib',
    templateUrl: 'scoreboard-bib.html'
  })

  export class ScoreBoardBib {

    
    athletesArray = [];
    differ: any;

      constructor (private storage: StorageProvider,
        private navCtrl: NavController,
        private navParams: NavParams,
        differs: IterableDiffers,
      private modalCtrl: ModalController) {
        this.differ = differs.find([]).create(null);
        this.getArray();
      }
      
      ngDoCheck() {
        const change = this.differ.diff(this.athletesArray);
        
        this.sortArray();
        console.log("change");
        
      }

      sortArray(){
        let arr;

        arr = this.athletesArray.sort((a, b) => a.time > b.time && 1 || -1);
        for(let i = 0; i < arr.length; i++){
            arr[i].place = 0;
        }

        for(let i = 0; i < arr.length; i++){
            arr[i].place = i + 1;
        }

        console.log("arr sorted" + JSON.stringify(arr));
        
        this.athletesArray = arr;
      }

      async getArray() {
         this.athletesArray = this.athletesArray.concat(this.navParams.get('arr'));
    
         console.log("ath arr " + JSON.stringify(this.athletesArray));
      }

      onBackMenu() {
        this.athletesArray.length = 0;
        this.navCtrl.pop();
      }

      openEditWindow(athlete){
        let modal = this.modalCtrl.create(EditAthleteData, {ath: athlete});
        modal.present();
    }
  }


// WEBPACK FOOTER //
// /src/components/scoreboard-bib/scoreboard-bib.ts